import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {Container, Row, Card, Col, Image} from "react-bootstrap";
import BusinessModal from "../Modals/otherproducts/businessmodal";
import QmsModal from "../Modals/otherproducts/qmsmodal";
import HmoModal from "../Modals/otherproducts/hmomodal";
import CmsModal from "../Modals/otherproducts/cmsmodal";

export default class OtherProducts extends Component {
  render() {
    const products = [
        {
            imgUrl: "/images/Business Process-Icon.png",
            cardTitle: "Business Process Management Services",
            cardSubTitle: "Intelligent Solutions",
            cardText: "Addresses the growing needs of companies to reduce\n" +
                "paperwork and elicit improved compliance by making\n" +
                "complex processes simpler, agile and sustainable",
            infoButton: <BusinessModal />
        },
        {
            imgUrl: "/images/Queue Monitoring-Icon.png",
            cardTitle: "Queue Monitoring System",
            cardSubTitle: "QRT (Queue, Resources, and Tasks) Specialist",
            cardText: "Addresses the management of member queueing in high\n" +
                "traffic clinics. It helps capture relevant queue\n" +
                "information as inputs for better reports on productivity\n" +
                "and performance, as well as patient wait and handling*/}\n" +
                "time.",
            infoButton: <QmsModal />
        },
        {
            imgUrl: "/images/HMO Member Portal-Icon.png",
            cardTitle: "HMO Member Portal",
            cardSubTitle: "Accessibility Achieved",
            cardText: "An online, self-service system that equips HMO Members\n" +
                "to conveniently view their profile, their covered\n" +
                "dependents, availment procedures, schedule of benefits\n" +
                "and exclusions, and utilization.",
            infoButton: <HmoModal />
        },
        {
            imgUrl: "/images/CMS-Icon.png",
            cardTitle: "Clinic Management System (CMS)",
            cardSubTitle: "Clinic Operations Fortified",
            cardText: "A flexible, integrated, and user-friendly solution to\n" +
                "support free-standing and multi-specialty clinics to\n" +
                "efficiently and effectively serve patients while\n" +
                "competently managing their administrative tasks.",
            infoButton: <CmsModal />
        },
    ];
    return (
      <div
        style={{
          backgroundColor: "#F7F7F7",
          paddingBottom: "5%",
          paddingTop: "5%"
        }}
      >
          <Container style={{ maxWidth: "80%", marginTop: "40px" }}>
              <div style={{ marginBottom: "5%" }} align="center" >
                  <h2>
                  <span style={{ color: "#49B544", font: "gotham bold"}}>
                      <b>Other Products</b>
                  </span>
                  </h2>
              </div>
              <Row className="g-4" style={{ marginBottom: "2%", fontSize: "15px"}}>
                  {products.map((product, index) => (
                      <Col key={index} md={6} className="d-flex">
                      <div
                          className="d-flex"
                          style={{ backgroundColor: "#EDEDED", width: "100%" }}
                      >
                          <Image
                              className="align-self-center"
                              alt=""
                              style={{
                                  height: "185px",
                                  width: "100%",
                                  objectFit: "contain",
                              }}
                              src={process.env.PUBLIC_URL + product.imgUrl}
                          />
                          <Card className="d-flex justify-content-center align-items-center" style={{ width: '100%', border: "none"}}>
                              <Card.Body className="d-flex flex-column">
                                  <Card.Title
                                      style={{
                                          color:"#49B544",
                                          fontWeight:"bold",
                                          fontSize: "20px"
                                      }}
                                  >
                                      {product.cardTitle}
                                  </Card.Title>
                                  <Card.Text>
                                      <span style={{ fontWeight: "bold" }}>
                                          {product.cardSubTitle}
                                      </span>
                                      <br />
                                      <p
                                          style={{
                                              fontSize: "13px",
                                              marginTop: "10px",
                                              color: "#A6A6A6"
                                          }}
                                      >
                                          {product.cardText}
                                      </p>
                                  </Card.Text>
                                  {product.infoButton}
                              </Card.Body>
                          </Card>
                      </div>
                  </Col>
                  ))}
              </Row>
          </Container>
      </div>
    );
  }
}
